import {
  Modal,
  Stack,
  Group,
  TextInput,
  Button,
  Textarea,
  Select,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import "./CreateNewsModal.css";

interface CreateNewsModalProps {
  opened: boolean;
  onClose: () => void;
  onSave: (formData: any) => void;
}

const CreateNewsModal: React.FC<CreateNewsModalProps> = ({
  opened,
  onClose,
  onSave,
}) => {
  const categories = [
    { id: 1, name: "We're hiring" },
    { id: 2, name: "Latest LinkedIn updates" },
    { id: 3, name: "Website promo" },
    { id: 4, name: "Promotions" },
    { id: 5, name: "Team updates" },
    { id: 6, name: "Employee benefits" },
    { id: 7, name: "Internal obligations" },
  ];

  const form = useForm({
    initialValues: {
      category: categories[4].id.toString(),
      title: "",
      description: "",
      imageUrl: "",
      linkUrl: "",
      location: "",
      site: "Remote",
    },

    validate: {
      category: (value) => (!value ? "Category cannot be empty" : null),
      title: (value) => (!value ? "Title cannot be empty" : null),
      linkUrl: (value, values) =>
        values.category === "2" && !value ? "Link Url cannot be empty" : null,
      location: (value, values) =>
        values.category === "1" && values.site == "On-site" && !value
          ? "Location cannot be empty"
          : null,
    },
  });

  const handleSubmit = (values: typeof form.values) => {
    onSave(values);
    form.reset();
    onClose();
  };

  const handleClose = () => {
    form.reset();
    onClose();
  };

  return (
    <Modal
      opened={opened}
      onClose={handleClose}
      title="Create New Post"
      withCloseButton={false}
      centered
      size="auto"
      classNames={{
        content: "news-modal-content",
        body: "news-modal-body",
        header: "news-modal-header",
        title: "news-modal-title",
        overlay: "custom-overlay",
      }}
    >
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack gap="1rem">
          <Select
            label="Category*"
            placeholder="Choose new type"
            data={categories.map((category: any) => ({
              value: category.id.toString(),
              label: category.name,
            }))}
            classNames={{
              input: "text-input",
            }}
            key={form.key("category")}
            {...form.getInputProps("category")}
          />
          <TextInput
            label="Title*"
            placeholder="Title"
            classNames={{
              input: "text-input",
            }}
            key={form.key("title")}
            {...form.getInputProps("title")}
          />
          {!["1", "2"].includes(form.values.category) && (
            <Textarea
              label="Description"
              placeholder="Description"
              classNames={{
                input: "text-input",
              }}
              key={form.key("description")}
              {...form.getInputProps("description")}
            />
          )}
          {!["1", "2"].includes(form.values.category) && (
            <TextInput
              label="Image Url"
              placeholder="Image Url here"
              classNames={{
                input: "text-input",
              }}
              key={form.key("imageUrl")}
              {...form.getInputProps("imageUrl")}
            />
          )}
          {["1", "2"].includes(form.values.category) && (
            <TextInput
              label="Link Url"
              placeholder="Link here"
              classNames={{
                input: "text-input",
              }}
              key={form.key("linkUrl")}
              {...form.getInputProps("linkUrl")}
            />
          )}
          {form.values.category === "1" && (
            <Group justify="space-between">
              <Select
                label="Site"
                placeholder="choose job site"
                data={["Remote", "On-site"]}
                classNames={{
                  input: "text-input",
                }}
                className="flex-1"
                key={form.key("site")}
                {...form.getInputProps("site")}
              />
              <TextInput
                label="Location"
                placeholder="Job Location"
                classNames={{
                  input: "text-input",
                }}
                key={form.key("location")}
                {...form.getInputProps("location")}
                className="flex-1"
              />
            </Group>
          )}
          <Group justify="end">
            <Button
              variant="filled"
              color="#030102"
              className="!rounded-lg !h-[2.5rem]"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="white"
              color="#030102"
              className="!rounded-lg !h-[2.20rem]"
            >
              Post
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default CreateNewsModal;
